import React, { useState, useEffect } from "react";
import { PropTypes } from "prop-types";

// COMPONENTS
import { VideoPlayer } from "@lululemon/ui-library";

import ZoomButton from "../../shared/components/zoom-button";
import useVideoPlayerAnalyticsTracking from "../hooks/use-video-player-analytics-tracking";

// STYLES
import styles from "../styles/video-carousel-item.module.scss";

function VideoCarouselItem({
  activeSlide,
  index,
  isMobile,
  openZoomModal,
  posterImageUrl,
  productImageAlt,
  pdpCarouselWWMTImageWidths,
  showZoomModal,
  totalSlides,
  url
}) {
  const [isHoveringOverVideo, setIsHoveringOverVideo] = useState(false);
  const isAdaptiveSource = url?.includes("m3u8");
  const trackingInfo = {
    type: "gallery-thumbnail",
    text: "",
    position: index + 1,
    totalCount: totalSlides,
    videoId: ""
  };

  const handleVideoRef = useVideoPlayerAnalyticsTracking(trackingInfo);

  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    if (!shouldRender && activeSlide >= index) {
      setShouldRender(true);
    }
  }, [activeSlide, index]);

  if (!shouldRender) {
    return <></>;
  }

  return (
    <div
      className={styles.videoWrapper}
      data-testid="video-wrapper"
      onMouseEnter={() => setIsHoveringOverVideo(true)}
      onMouseLeave={() => setIsHoveringOverVideo(false)}
    >
      <VideoPlayer
        allowAudio={false}
        allowFullscreen={false}
        className={styles.videoContainer}
        landscapeSource={!isAdaptiveSource ? url : undefined}
        landscapeAdaptiveSource={isAdaptiveSource ? url : undefined}
        portraitSource={!isAdaptiveSource ? url : undefined}
        portraitAdaptiveSource={isAdaptiveSource ? url : undefined}
        playPauseButtonClassName={
          isHoveringOverVideo ? styles.playPauseButtonHover : ""
        }
        portraitPosterImageProps={{
          src: posterImageUrl,
          alt: productImageAlt,
          sizes: pdpCarouselWWMTImageWidths
        }}
        videoClassName={styles.video}
        autoplay={true}
        minimalButtonAlignment="bottomLeft"
        variant="minimal"
        refs={{
          video: handleVideoRef
        }}
      />
      {!isMobile && showZoomModal && (
        <ZoomButton
          index={index}
          tabIndex={activeSlide === index ? "0" : "-1"}
          buttonClassNames={styles.videoOverlay}
          handleZoomButtonClick={() =>
            openZoomModal && openZoomModal(activeSlide)
          }
        />
      )}
    </div>
  );
}

VideoCarouselItem.propTypes = {
  url: PropTypes.string.isRequired,
  posterImageUrl: PropTypes.string.isRequired,
  productImageAlt: PropTypes.string.isRequired,
  isMobile: PropTypes.bool,
  index: PropTypes.number.isRequired,
  activeSlide: PropTypes.number.isRequired,
  openZoomModal: PropTypes.func.isRequired,
  showZoomModal: PropTypes.bool
};

VideoCarouselItem.defaultProps = {
  isMobile: false,
  showZoomModal: false
};

export default VideoCarouselItem;
